import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import type { OptimisticStatus } from '../../types/chat'
import { MiniLoader } from '../Common'
import { Button } from '../Common/Button'

type SyncStatusIndicatorProps = {
  status?: OptimisticStatus
  onRetry?: () => void
}

export const SyncStatusIndicator = ({ status = 'synced', onRetry }: SyncStatusIndicatorProps) => {
  if (status === 'synced') {
    return (
      <span className="chatSyncStatus chatSyncStatus--synced" title="Synced">
        <CheckRoundedIcon fontSize="inherit" />
      </span>
    )
  }
  if (status === 'failed' || status === 'abandoned') {
    return (
      <span className="chatSyncStatus chatSyncStatus--failed">
        <ErrorOutlineRoundedIcon fontSize="inherit" />
        {status === 'abandoned' ? 'Abandoned' : 'Failed'}
        {onRetry ? <Button size="sm" variant="tertiary" onClick={onRetry}>Retry</Button> : null}
      </span>
    )
  }
  return (
    <span className={`chatSyncStatus chatSyncStatus--${status}`}>
      <MiniLoader tone={status === 'uploading' ? 'upload' : 'default'} size="xs" label={status === 'uploading' ? 'Uploading' : 'Sending'} inline />
    </span>
  )
}
